import React from 'react';
import { Card, CardContent } from './ui/card';
import { Heart } from 'lucide-react';
import { mockData } from '../mock';

const FavoritesSection = () => {
  const { favorites } = mockData;

  return (
    <section id="coups-de-coeur" className="section-padding bg-warm-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <Heart className="h-8 w-8 text-primary mr-3" />
            <h2 className="text-4xl font-serif font-bold text-primary">
              {favorites.title}
            </h2>
          </div>
        </div>

        <Card className="border-2 border-gray-100 shadow-lg">
          <CardContent className="p-8">
            <div className="space-y-8">
              {/* Introduction */}
              <p className="text-lg text-gray-700 leading-relaxed text-center italic">
                {favorites.intro}
              </p>

              <div className="divider"></div>

              {/* Supporters */}
              <div className="space-y-4">
                {favorites.supporters.map((supporter, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <span className="text-primary font-bold mt-1">•</span>
                    <p className="text-gray-700 leading-relaxed">
                      {supporter}
                    </p>
                  </div>
                ))}
              </div>

              <div className="divider"></div>

              {/* Artists introduction */}
              <p className="text-lg text-gray-700 leading-relaxed font-medium">
                {favorites.artists_intro}
              </p>

              {/* Artists */}
              <div className="space-y-3">
                {favorites.artists.map((artist, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <span className="text-primary font-bold mt-1">•</span>
                    <p className="text-gray-700 leading-relaxed">
                      {artist}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="text-center mt-8">
          <p className="text-gray-600 italic">
            Merci à tous ceux qui ont contribué à faire du 4A un lieu unique
          </p>
        </div>
      </div>
    </section>
  );
};

export default FavoritesSection;